import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"; import { componentToRx } from "app/logic/rx";
import { fa } from "typed-font-awesome";

type Entity = models.MovimientoCajaViewDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Fecha", cell: x => ({ data: kea.toDate(x.Fecha) }) },
    { title: "Tipo movimiento", cell: x => ({ data: models.TipoMovimientoCajaView[x.Tipo] }) },
    { title: "Caja", cell: x => ({ data: x.NombreCaja }) },
    { title: "Abono", cell: x => ({ data: kea.formatCurrency(x.Abono) }) },
    { title: "Cargo", cell: x => ({ data: kea.formatCurrency(x.Cargo) }) },
    { title: "Abono acumulado", cell: x => ({ data: kea.formatCurrency(x.AbonosAcum) }) },
    { title: "Cargo acumulado", cell: x => ({ data: kea.formatCurrency(x.CargosAcum) }) },
    { title: "Usuario", cell: x => ({ data: x.NombreUsuario }) },
    { title: "Forma pago", cell: x => ({ data: models.FormaPagoMovimientoCaja[x.FormaPago] }) },
    { title: "Referencia", cell: x => ({ data: x.Referencia }) },
];

export interface BotonesListaDeps {

}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesListaDeps): Column[] {
    const botones = kea.columnaBotones([
    ]);

    return [...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/movimientoscaja/list/columns.tsx